// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_93444fe79c--tooltip--Jsh1z","arrow_tooltip":"_93444fe79c--arrow_tooltip--SRU9V","arrow":"_93444fe79c--arrow--A4pue"};